import lmsAPI from "./lmsAPI";

class FieldsService {
  async index() {
    const res = await lmsAPI.get(`/fields/`);
    return res.data;
  }

  async get(id) {
    const res = await lmsAPI.get(`/fields/${id}`);
    return res.data;
  }

  async update(id, fieldParams) {
    const res = await lmsAPI.put(`/fields/${id}`, { field: fieldParams });
    return res.data;
  }

  async create(fieldParams) {
    const res = await lmsAPI.post(`/fields/`, { field: fieldParams });
    return res.data;
  }

  async delete(id) {
    const res = await lmsAPI.delete(`/fields/${id}`);
    return res.data;
  }
}

export default new FieldsService();
